import type { LucideIcon } from 'lucide-react';
import {
  Factory,
  GitBranch,
  LayoutGrid,
  LayoutList,
  Network,
  Sparkles,
  Table2,
  Waypoints,
} from 'lucide-react';
import type { ValueChainWorkspaceTab } from '@/types/valueChain';

const TABS: Array<{ id: ValueChainWorkspaceTab; label: string; icon: LucideIcon }> = [
  { id: 'hierarchy', label: 'Hierarchy', icon: Network },
  { id: 'revenue-map', label: 'Revenue Map', icon: LayoutGrid },
  { id: 'chain', label: 'Chain View', icon: Waypoints },
  { id: 'graph', label: 'Graph', icon: GitBranch },
  { id: 'opportunities', label: 'Opportunities', icon: Sparkles },
  { id: 'exposure', label: 'Company Exposure', icon: LayoutList },
  { id: 'manufacturing', label: 'Manufacturing', icon: Factory },
  { id: 'bom', label: 'BOM Estimate', icon: Table2 },
];

type Props = {
  active: ValueChainWorkspaceTab | null;
  onChange: (tab: ValueChainWorkspaceTab) => void;
};

export function WorkspaceTabs({ active, onChange }: Props) {
  return (
    <div className="flex flex-wrap gap-1 border-b border-gray-200 px-6">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const selected = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`relative inline-flex items-center gap-2 px-3 py-3 text-sm ${
              selected ? 'font-medium text-blue-700' : 'text-gray-500 hover:text-gray-800'
            }`}
          >
            <Icon className="h-4 w-4" />
            {tab.label}
            {selected ? (
              <span className="absolute inset-x-2 -bottom-px h-0.5 rounded-full bg-blue-600" />
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
